import {
  purpurColorBackgroundInteractiveAutoFill,
  purpurColorBackgroundInteractiveDestructive,
  purpurColorBackgroundInteractiveDestructiveActive,
  purpurColorBackgroundInteractiveDestructiveHover,
  purpurColorBackgroundInteractiveDisabled,
  purpurColorBackgroundInteractiveDisabledNegative,
  purpurColorBackgroundInteractiveExpressive,
  purpurColorBackgroundInteractiveExpressiveActive,
  purpurColorBackgroundInteractiveExpressiveActiveNegative,
  purpurColorBackgroundInteractiveExpressiveHover,
  purpurColorBackgroundInteractiveExpressiveHoverNegative,
  purpurColorBackgroundInteractiveExpressiveNegative,
  purpurColorBackgroundInteractiveInactive,
  purpurColorBackgroundInteractiveInactiveNegative,
  purpurColorBackgroundInteractivePrimary,
  purpurColorBackgroundInteractivePrimaryActive,
  purpurColorBackgroundInteractivePrimaryActiveNegative,
  purpurColorBackgroundInteractivePrimaryHover,
  purpurColorBackgroundInteractivePrimaryHoverNegative,
  purpurColorBackgroundInteractivePrimaryNegative,
  purpurColorBackgroundInteractiveReadOnly,
  purpurColorBackgroundInteractiveReadOnlyNegative,
  purpurColorBackgroundInteractiveTransparentActive,
  purpurColorBackgroundInteractiveTransparentActiveNegative,
  purpurColorBackgroundInteractiveTransparentHover,
  purpurColorBackgroundInteractiveTransparentHoverNegative,
  purpurColorBackgroundOnImage,
  purpurColorBackgroundOnImageNegative,
  purpurColorBackgroundPrimary,
  purpurColorBackgroundPrimaryNegative,
  purpurColorBackgroundSecondary,
  purpurColorBackgroundSecondaryNegative,
  purpurColorBackgroundStatusAttention,
  purpurColorBackgroundStatusBlackFriday,
  purpurColorBackgroundStatusErrorMedium,
  purpurColorBackgroundStatusErrorStrong,
  purpurColorBackgroundStatusErrorStrongNegative,
  purpurColorBackgroundStatusInfoMedium,
  purpurColorBackgroundStatusInfoStrong,
  purpurColorBackgroundStatusNeutral,
  purpurColorBackgroundStatusSpecial,
  purpurColorBackgroundStatusSuccessMedium,
  purpurColorBackgroundStatusSuccessStrong,
  purpurColorBackgroundStatusSuccessStrongNegative,
  purpurColorBackgroundStatusWarningMedium,
  purpurColorBackgroundStatusWarningStrong,
  purpurColorBackgroundStatusWarningStrongNegative,
  purpurColorBackgroundToneOnTonePrimary,
  purpurColorBackgroundToneOnToneQuaternary,
  purpurColorBackgroundToneOnToneSecondary,
  purpurColorBackgroundToneOnToneTertiary,
  purpurColorBorderInteractiveExpressive,
  purpurColorBorderInteractiveFocus,
  purpurColorBorderInteractivePrimary,
  purpurColorBorderInteractivePrimaryActive,
  purpurColorBorderInteractivePrimaryActiveNegative,
  purpurColorBorderInteractivePrimaryHover,
  purpurColorBorderInteractivePrimaryHoverNegative,
  purpurColorBorderInteractivePrimaryNegative,
  purpurColorBorderInteractiveSelected,
  purpurColorBorderInteractiveSubtle,
  purpurColorBorderInteractiveSubtleHover,
  purpurColorBorderInteractiveSubtleHoverNegative,
  purpurColorBorderInteractiveSubtleNegative,
  purpurColorBorderMedium,
  purpurColorBorderMediumNegative,
  purpurColorBorderStatusError,
  purpurColorBorderStatusErrorNegative,
  purpurColorBorderStatusInfo,
  purpurColorBorderStatusSuccess,
  purpurColorBorderStatusSuccessNegative,
  purpurColorBorderStatusWarning,
  purpurColorBorderStrong,
  purpurColorBorderStrongNegative,
  purpurColorBorderWeak,
  purpurColorBorderWeakNegative,
  purpurColorBrandBeige,
  purpurColorBrandCorePurple,
  purpurColorBrandDeepBeige,
  purpurColorBrandDeepPurple,
  purpurColorBrandLightBeige,
  purpurColorBrandLightPurple,
  purpurColorBrandOffBlack,
  purpurColorBrandWhite,
  purpurColorTextDefault,
  purpurColorTextDefaultNegative,
  purpurColorTextInteractiveOnDestructive,
  purpurColorTextInteractiveOnExpressive,
  purpurColorTextInteractiveOnExpressiveActive,
  purpurColorTextInteractiveOnExpressiveActiveNegative,
  purpurColorTextInteractiveOnExpressiveHover,
  purpurColorTextInteractiveOnExpressiveHoverNegative,
  purpurColorTextInteractiveOnExpressiveNegative,
  purpurColorTextInteractiveOnPrimary,
  purpurColorTextInteractiveOnPrimaryNegative,
  purpurColorTextInteractivePrimary,
  purpurColorTextInteractivePrimaryActive,
  purpurColorTextInteractivePrimaryActiveNegative,
  purpurColorTextInteractivePrimaryHover,
  purpurColorTextInteractivePrimaryHoverNegative,
  purpurColorTextInteractivePrimaryNegative,
  purpurColorTextInteractiveSelected,
  purpurColorTextMedium,
  purpurColorTextMediumNegative,
  purpurColorTextStatusAttention,
  purpurColorTextStatusBlackFriday,
  purpurColorTextStatusDiscount,
  purpurColorTextStatusErrorMedium,
  purpurColorTextStatusErrorMediumNegative,
  purpurColorTextStatusErrorStrong,
  purpurColorTextStatusErrorStrongNegative,
  purpurColorTextStatusInfoMedium,
  purpurColorTextStatusInfoStrong,
  purpurColorTextStatusNeutral,
  purpurColorTextStatusSpecial,
  purpurColorTextStatusSuccessMedium,
  purpurColorTextStatusSuccessStrong,
  purpurColorTextStatusSuccessStrongNegative,
  purpurColorTextStatusWarningMedium,
  purpurColorTextStatusWarningMediumNegative,
  purpurColorTextStatusWarningStrong,
  purpurColorTextToneOnTonePrimary,
  purpurColorTextToneOnToneSecondary,
  purpurColorTextToneOnToneTertiary,
  purpurColorTextWeak,
  purpurColorTextWeakNegative,
} from "@purpur/tokens";

import type { ThemeProps } from "./theme-props";

export const light = {
  colorBrandDeepPurple: purpurColorBrandDeepPurple,
  colorBrandCorePurple: purpurColorBrandCorePurple,
  colorBrandLightPurple: purpurColorBrandLightPurple,
  colorBrandDeepBeige: purpurColorBrandDeepBeige,
  colorBrandBeige: purpurColorBrandBeige,
  colorBrandLightBeige: purpurColorBrandLightBeige,
  colorBrandOffBlack: purpurColorBrandOffBlack,
  colorBrandWhite: purpurColorBrandWhite,

  colorTextDefault: purpurColorTextDefault,
  colorTextMedium: purpurColorTextMedium,
  colorTextWeak: purpurColorTextWeak,
  colorTextDefaultNegative: purpurColorTextDefaultNegative,
  colorTextMediumNegative: purpurColorTextMediumNegative,
  colorTextWeakNegative: purpurColorTextWeakNegative,

  colorTextInteractivePrimary: purpurColorTextInteractivePrimary,
  colorTextInteractivePrimaryHover: purpurColorTextInteractivePrimaryHover,
  colorTextInteractivePrimaryActive: purpurColorTextInteractivePrimaryActive,
  colorTextInteractiveOnPrimary: purpurColorTextInteractiveOnPrimary,
  colorTextInteractiveOnExpressive: purpurColorTextInteractiveOnExpressive,
  colorTextInteractiveOnExpressiveHover: purpurColorTextInteractiveOnExpressiveHover,
  colorTextInteractiveOnExpressiveActive: purpurColorTextInteractiveOnExpressiveActive,
  colorTextInteractiveOnDestructive: purpurColorTextInteractiveOnDestructive,
  colorTextInteractiveSelected: purpurColorTextInteractiveSelected,
  colorTextInteractivePrimaryNegative: purpurColorTextInteractivePrimaryNegative,
  colorTextInteractivePrimaryHoverNegative: purpurColorTextInteractivePrimaryHoverNegative,
  colorTextInteractivePrimaryActiveNegative: purpurColorTextInteractivePrimaryActiveNegative,
  colorTextInteractiveOnPrimaryNegative: purpurColorTextInteractiveOnPrimaryNegative,
  colorTextInteractiveOnExpressiveNegative: purpurColorTextInteractiveOnExpressiveNegative,
  colorTextInteractiveOnExpressiveHoverNegative:
    purpurColorTextInteractiveOnExpressiveHoverNegative,
  colorTextInteractiveOnExpressiveActiveNegative:
    purpurColorTextInteractiveOnExpressiveActiveNegative,

  colorTextStatusInfoMedium: purpurColorTextStatusInfoMedium,
  colorTextStatusInfoStrong: purpurColorTextStatusInfoStrong,
  colorTextStatusSuccessMedium: purpurColorTextStatusSuccessMedium,
  colorTextStatusSuccessStrong: purpurColorTextStatusSuccessStrong,
  colorTextStatusWarningMedium: purpurColorTextStatusWarningMedium,
  colorTextStatusWarningStrong: purpurColorTextStatusWarningStrong,
  colorTextStatusErrorMedium: purpurColorTextStatusErrorMedium,
  colorTextStatusErrorStrong: purpurColorTextStatusErrorStrong,
  colorTextStatusNeutral: purpurColorTextStatusNeutral,
  colorTextStatusSpecial: purpurColorTextStatusSpecial,
  colorTextStatusAttention: purpurColorTextStatusAttention,
  colorTextStatusDiscount: purpurColorTextStatusDiscount,
  colorTextStatusBlackFriday: purpurColorTextStatusBlackFriday,
  colorTextStatusSuccessStrongNegative: purpurColorTextStatusSuccessStrongNegative,
  colorTextStatusErrorMediumNegative: purpurColorTextStatusErrorMediumNegative,
  colorTextStatusErrorStrongNegative: purpurColorTextStatusErrorStrongNegative,
  colorTextStatusWarningMediumNegative: purpurColorTextStatusWarningMediumNegative,

  colorTextToneOnTonePrimary: purpurColorTextToneOnTonePrimary,
  colorTextToneOnToneSecondary: purpurColorTextToneOnToneSecondary,
  colorTextToneOnToneTertiary: purpurColorTextToneOnToneTertiary,

  colorBackgroundPrimary: purpurColorBackgroundPrimary,
  colorBackgroundSecondary: purpurColorBackgroundSecondary,
  colorBackgroundOnImage: purpurColorBackgroundOnImage,
  colorBackgroundPrimaryNegative: purpurColorBackgroundPrimaryNegative,
  colorBackgroundSecondaryNegative: purpurColorBackgroundSecondaryNegative,
  colorBackgroundOnImageNegative: purpurColorBackgroundOnImageNegative,

  colorBackgroundInteractivePrimary: purpurColorBackgroundInteractivePrimary,
  colorBackgroundInteractivePrimaryHover: purpurColorBackgroundInteractivePrimaryHover,
  colorBackgroundInteractivePrimaryActive: purpurColorBackgroundInteractivePrimaryActive,
  colorBackgroundInteractiveExpressive: purpurColorBackgroundInteractiveExpressive,
  colorBackgroundInteractiveExpressiveHover: purpurColorBackgroundInteractiveExpressiveHover,
  colorBackgroundInteractiveExpressiveActive: purpurColorBackgroundInteractiveExpressiveActive,
  colorBackgroundInteractiveTransparentHover: purpurColorBackgroundInteractiveTransparentHover,
  colorBackgroundInteractiveTransparentActive: purpurColorBackgroundInteractiveTransparentActive,
  colorBackgroundInteractiveDisabled: purpurColorBackgroundInteractiveDisabled,
  colorBackgroundInteractiveReadOnly: purpurColorBackgroundInteractiveReadOnly,
  colorBackgroundInteractiveInactive: purpurColorBackgroundInteractiveInactive,
  colorBackgroundInteractiveDestructive: purpurColorBackgroundInteractiveDestructive,
  colorBackgroundInteractiveDestructiveHover: purpurColorBackgroundInteractiveDestructiveHover,
  colorBackgroundInteractiveDestructiveActive: purpurColorBackgroundInteractiveDestructiveActive,
  colorBackgroundInteractiveAutoFill: purpurColorBackgroundInteractiveAutoFill,
  colorBackgroundInteractivePrimaryNegative: purpurColorBackgroundInteractivePrimaryNegative,
  colorBackgroundInteractivePrimaryHoverNegative:
    purpurColorBackgroundInteractivePrimaryHoverNegative,
  colorBackgroundInteractivePrimaryActiveNegative:
    purpurColorBackgroundInteractivePrimaryActiveNegative,
  colorBackgroundInteractiveExpressiveNegative: purpurColorBackgroundInteractiveExpressiveNegative,
  colorBackgroundInteractiveExpressiveHoverNegative:
    purpurColorBackgroundInteractiveExpressiveHoverNegative,
  colorBackgroundInteractiveExpressiveActiveNegative:
    purpurColorBackgroundInteractiveExpressiveActiveNegative,
  colorBackgroundInteractiveTransparentHoverNegative:
    purpurColorBackgroundInteractiveTransparentHoverNegative,
  colorBackgroundInteractiveTransparentActiveNegative:
    purpurColorBackgroundInteractiveTransparentActiveNegative,
  colorBackgroundInteractiveDisabledNegative: purpurColorBackgroundInteractiveDisabledNegative,
  colorBackgroundInteractiveInactiveNegative: purpurColorBackgroundInteractiveInactiveNegative,
  colorBackgroundInteractiveReadOnlyNegative: purpurColorBackgroundInteractiveReadOnlyNegative,

  colorBackgroundStatusInfoMedium: purpurColorBackgroundStatusInfoMedium,
  colorBackgroundStatusInfoStrong: purpurColorBackgroundStatusInfoStrong,
  colorBackgroundStatusSuccessMedium: purpurColorBackgroundStatusSuccessMedium,
  colorBackgroundStatusSuccessStrong: purpurColorBackgroundStatusSuccessStrong,
  colorBackgroundStatusWarningMedium: purpurColorBackgroundStatusWarningMedium,
  colorBackgroundStatusWarningStrong: purpurColorBackgroundStatusWarningStrong,
  colorBackgroundStatusErrorMedium: purpurColorBackgroundStatusErrorMedium,
  colorBackgroundStatusErrorStrong: purpurColorBackgroundStatusErrorStrong,
  colorBackgroundStatusNeutral: purpurColorBackgroundStatusNeutral,
  colorBackgroundStatusSpecial: purpurColorBackgroundStatusSpecial,
  colorBackgroundStatusAttention: purpurColorBackgroundStatusAttention,
  colorBackgroundStatusBlackFriday: purpurColorBackgroundStatusBlackFriday,
  colorBackgroundStatusSuccessStrongNegative: purpurColorBackgroundStatusSuccessStrongNegative,
  colorBackgroundStatusWarningStrongNegative: purpurColorBackgroundStatusWarningStrongNegative,
  colorBackgroundStatusErrorStrongNegative: purpurColorBackgroundStatusErrorStrongNegative,

  colorBackgroundToneOnTonePrimary: purpurColorBackgroundToneOnTonePrimary,
  colorBackgroundToneOnToneSecondary: purpurColorBackgroundToneOnToneSecondary,
  colorBackgroundToneOnToneTertiary: purpurColorBackgroundToneOnToneTertiary,
  colorBackgroundToneOnToneQuaternary: purpurColorBackgroundToneOnToneQuaternary,

  colorBorderWeak: purpurColorBorderWeak,
  colorBorderMedium: purpurColorBorderMedium,
  colorBorderStrong: purpurColorBorderStrong,
  colorBorderWeakNegative: purpurColorBorderWeakNegative,
  colorBorderMediumNegative: purpurColorBorderMediumNegative,
  colorBorderStrongNegative: purpurColorBorderStrongNegative,

  colorBorderInteractivePrimary: purpurColorBorderInteractivePrimary,
  colorBorderInteractivePrimaryHover: purpurColorBorderInteractivePrimaryHover,
  colorBorderInteractivePrimaryActive: purpurColorBorderInteractivePrimaryActive,
  colorBorderInteractiveFocus: purpurColorBorderInteractiveFocus,
  colorBorderInteractiveExpressive: purpurColorBorderInteractiveExpressive,
  colorBorderInteractiveSubtle: purpurColorBorderInteractiveSubtle,
  colorBorderInteractiveSubtleHover: purpurColorBorderInteractiveSubtleHover,
  colorBorderInteractiveSelected: purpurColorBorderInteractiveSelected,
  colorBorderInteractivePrimaryNegative: purpurColorBorderInteractivePrimaryNegative,
  colorBorderInteractivePrimaryHoverNegative: purpurColorBorderInteractivePrimaryHoverNegative,
  colorBorderInteractivePrimaryActiveNegative: purpurColorBorderInteractivePrimaryActiveNegative,
  colorBorderInteractiveSubtleNegative: purpurColorBorderInteractiveSubtleNegative,
  colorBorderInteractiveSubtleHoverNegative: purpurColorBorderInteractiveSubtleHoverNegative,

  colorBorderStatusError: purpurColorBorderStatusError,
  colorBorderStatusWarning: purpurColorBorderStatusWarning,
  colorBorderStatusInfo: purpurColorBorderStatusInfo,
  colorBorderStatusSuccess: purpurColorBorderStatusSuccess,
  colorBorderStatusErrorNegative: purpurColorBorderStatusErrorNegative,
  colorBorderStatusSuccessNegative: purpurColorBorderStatusSuccessNegative,
} satisfies ThemeProps;
